export default __webpack_public_path__ + "static/Marketing_Masters-d42ff1b6dbca223a8eb16ec4feb8570d.png";